import { render, staticRenderFns } from "./Folders.vue?vue&type=template&id=6bbf6258&scoped=true&"
import script from "./Folders.vue?vue&type=script&lang=ts&"
export * from "./Folders.vue?vue&type=script&lang=ts&"
import style0 from "./Folders.vue?vue&type=style&index=0&id=6bbf6258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf6258",
  null
  
)

export default component.exports